module.exports = __webpack_public_path__ + "img/wikilogo.48367a59.png";